import { navigate } from '../router.js';

export function renderRegister() {
  navigate('#/login');
}
